module.exports = __webpack_public_path__ + "img/tablet.538b9dc7.png";